import { can, type PersonRef, type SessionUser, type SpaceDetail } from '@dpw/shared';

export interface PersonOption { value: string; label: string; ref: PersonRef }

/** Team members and client contacts of a space, for "Requested by" and "Waiting on". */
export function peopleOptions(space: SpaceDetail, me: SessionUser): PersonOption[] {
  const team = [...space.members];
  if (!team.some(m => m.id === me.id)) team.unshift({ id: me.id, name: me.name, initials: me.initials, title: null, role: 'member', userRole: me.role });
  return [
    ...team.map(m => ({ value: `user:${m.id}`, label: m.name, ref: { kind: 'user' as const, id: m.id } })),
    ...space.contacts.map(c => ({ value: `contact:${c.id}`, label: `${c.name}${c.organisation ? ` (${c.organisation})` : ' (client)'}`, ref: { kind: 'contact' as const, id: c.id } })),
  ];
}

export const refValue = (r: { kind: string; id: string } | null | undefined) => (r ? `${r.kind}:${r.id}` : '');
export function parseRef(v: string): PersonRef | null {
  const [kind, id] = v.split(':');
  return (kind === 'user' || kind === 'contact') && id ? { kind, id } : null;
}

/** People who can own activities or lead a track in this space. Partners read and ask; they never own. */
export function teamOf(space: SpaceDetail, me: SessionUser) {
  const t = space.members.filter(m => can(m.userRole, 'activity.own')).map(m => ({ id: m.id, name: m.name }));
  if (!t.some(m => m.id === me.id) && can(me.role, 'activity.own')) t.unshift({ id: me.id, name: me.name });
  return t;
}
